import {Injectable, Inject} from '@angular/core';
import {Table} from "../../model/table";
import {TableChangeLog } from "../../model/tableChangeLog";

import {Observable, Subject} from "rxjs";


import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class TableService {

  private sdkDb;
  private tableRef;
  private tableChangeLogRef;

  private _currentTable$: Subject<Table> = new Subject<Table>();


  public  table$: FirebaseListObservable<any>;

  constructor(
    private db:AngularFireDatabase


  ) {
    this.sdkDb = db.app.database().ref();
    this.tableRef =  db.list('/tables');
    this.tableChangeLogRef = db.list('/tableChangeLog');
  }


  tableDisconnect(){
    this.tableRef.onDisconnect().set("Table Disconected");
    // this.sdkDb.onDisconnect().set("Table Disconected");

  }

  createMultipleTables(table:Table,numberOfTables:number,startingAtTable:number){


    let tableNumber = startingAtTable;
    let tableLable = " "
    for(let i=1;i<=numberOfTables;i++){
      if (tableNumber < 10) {
        tableLable = "0" + tableNumber
      } else {
        tableLable = "" + tableNumber
      }
      table.tableName = '# '+  tableLable;
      this.tableRef.push(table);
      tableNumber++;


    }



  }



  getTables(restaurantId:string):Observable<Table[]>{


    // console.log(restaurantId);

    const tables$ = this.db.list('tables',{
      query:{
        orderByChild:'restaurant_id',
        equalTo:restaurantId
      }
    })
      .map(Table.fromJsonList);


    return tables$
  };



  setCurrentTable(table:Table) {
    this._currentTable$.next(table);

  }


  getTableByKey(tableKey: any) {

    const table$ = this.db.list('tables',{
      query:{
        orderByKey: true,
        equalTo:tableKey
      }
    })
      .filter(result => result && result.length > 0)
      .map(result => Table.fromJson(result[0]));

      // .do(result => console.log(result));

    return table$;

  }

  saveTable(tableP: Table) :Observable <any> {



    let tableId = tableP.$key;
    const tableToSave = Object.assign({},tableP);
    delete(tableToSave.$key);
    let dataToSave = {};
    dataToSave["tables/"+tableId ] = tableToSave;
    return this.firebaseUpdate(dataToSave);

        // TODO: Make an Entry on table change Log

  }


  private firebaseUpdate(dataToSave: {}) {

    const subject = new Subject();

    this.sdkDb.update(dataToSave)
      .then(

        val =>{
          subject.next(val);
          subject.complete();

        },
        err =>{

          subject.error(err);
          subject.complete();

        }
      );

    return subject.asObservable();
  }



  setAllTablesEmpty(restaurantId:string) {

    this.sdkDb.child('tables/'+restaurantId).update({status:"Empty"});
    this.sdkDb.child('tables/'+restaurantId).update({statusForTable:'<span class=\"status-class Empty\">Empty</span>'});

  }

  private setStatustoEmpty(localTables: any) {
    localTables.forEach((element) =>{
      element.status = "Empty";
      element.statusForTable = "<span class=\"status-class Empty\">Empty</span>",
      this.saveTable(element);
    })
  }


  createTable(table:Table) {

    const tabletoSave = Object.assign({},table);
    const newTableKey = this.sdkDb.child('tables').push().key;


    let dataToSave = {};

    dataToSave["tables/"+newTableKey] = tabletoSave;

    return this.firebaseUpdate(dataToSave);


  }


  createTableChageLog(tableChangeRecord:TableChangeLog){

    const tablelogtoSave = Object.assign({},tableChangeRecord);
    const changeTableLogKey = this.sdkDb.child('tableChangeLog').push().key;


    let dataToSave = {};

    dataToSave["tableChangeLog/"+tableChangeRecord.restaurant_id+"/"+changeTableLogKey] = tablelogtoSave;


    return this.firebaseUpdate(dataToSave);

  }


  createDeleteLog(table:Object) {

    const tabletoSave = Object.assign({},table);
    const deleteTableKey = this.sdkDb.child('dellog').push().key;


    let dataToSave = {};

    dataToSave["dellog/"+deleteTableKey] = tabletoSave;


    return this.firebaseUpdate(dataToSave);


  }

    deleteTable(tableP: Table) :Observable <any>  {

      let tableId = tableP.$key;
      const tableToSave = Object.assign({},tableP);
      delete(tableToSave.$key);
      let thisRef = "tables/"+tableId;

      return this.firebaseDelete(thisRef);

    }

  private firebaseDelete(dataToDelete:string){



    const subject = new Subject();

    this.sdkDb.child(dataToDelete).remove()
        .then(
            val =>{
              subject.next(val);
              subject.complete();

            },
            err =>{
              subject.error(err);
              subject.complete();

            }
        );

    return subject.asObservable();

  }



}





// WEBPACK FOOTER //
// ./src/app/shared/services/table/table.service.ts